import script from "./EmbedChatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbedChatPage.vue?vue&type=script&setup=true&lang=js"

import "./EmbedChatPage.vue?vue&type=style&index=0&id=41510dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41510dec"]])

export default __exports__